module.exports = __webpack_public_path__ + "img/dingwei.81b9e20e.gif";